import styled from "styled-components";

export const ModalBody = styled.div`
	margin-top: 10px;
`;

export const SelectContainer = styled.div`
	margin-top: 20px;
`;
